const BASE_URL = "/store";


export default [
  // {
  //   path: `${BASE_URL}`,
  //   name: 'Payable',
  //   component: () => import('@/pages/store/Index.vue'),
  // },
 
  {
    path: `${BASE_URL}/store-requisition`,
    name: "Store Requisition",
    component: () => import("@/pages/store/storeRequisition/Index.vue"),
  },
  {
    path: `${BASE_URL}/outstanding-store-requisition`,
    name: "Outstanding Store Requisition",
    component: () => import("@/pages/store/outstandingStoreRequisition/Index.vue"),
  },
  {
    path: `${BASE_URL}/store-requisition-detail`,
    name: "Store Requisition Detail",
    component: () => import("@/pages/store/storeRequisitionDetail/Index.vue"),
  },
  {
    path: `${BASE_URL}/store-requisition-template`,
    name: "Store Requisition Template",
    component: () => import("@/pages/store/storeRequisitionTemplate/Index.vue"),
  },
  {
    path: `${BASE_URL}/inter-department-transfer`,
    name: "Inter Department Transfer",
    component: () => import("@/pages/store/interDepartmentTransfer/Index.vue"),
  },
  {
    path: `${BASE_URL}/inter-department-transfer-detail`,
    name: "Inter Department Transfer Detail",
    component: () => import("@/pages/store/interDepartmentTransferDetail/Index.vue"),
  },
];
